__turbopack_context__.v({
  "buttonTypography": "_08T01a_buttonTypography",
  "line": "_08T01a_line",
  "list": "_08T01a_list",
  "wrapper": "_08T01a_wrapper",
});
